var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTeamMemberPlaceholder = function SvgTeamMemberPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186 186",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M0 0h186v186H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M92.5 33c-16.14 0-29.24 12.86-29.24 28.7 0 15.83 13.1 28.7 29.24 28.7s29.24-12.87 29.24-28.7c0-15.84-13.1-28.7-29.24-28.7Zm0 5.22c13.2 0 23.92 10.52 23.92 23.48 0 12.95-10.72 23.47-23.92 23.47-13.2 0-23.92-10.52-23.92-23.47 0-12.96 10.72-23.48 23.92-23.48Zm0 57.38c-27.89 0-50.5 22.2-50.5 49.58a7.9 7.9 0 0 0 7.97 7.82h85.06a7.9 7.9 0 0 0 7.97-7.82c0-27.38-22.61-49.57-50.5-49.57Zm0 5.23c-24.95 0-45.18 19.85-45.18 44.34a2.63 2.63 0 0 0 2.65 2.61h85.06a2.64 2.64 0 0 0 2.66-2.6c0-24.5-20.23-44.35-45.19-44.35Z",
    clipRule: "evenodd"
  })));
};
export default SvgTeamMemberPlaceholder;